import { Spin } from 'antd'
import type { FC, ReactNode } from 'react'
import logo from '../../public/logo-mrs.png'

type MainLayoutProps = {
    children: ReactNode
    loading?: boolean
}
export const MainLayout: FC<MainLayoutProps> = ({ children, loading }) => {
    return (
        <main className="container">
            <div className="main-layout">
                <img src={logo.toString()} alt="mrs logo" />
                {loading ? (
                    <div className="p2 t-center">
                        <Spin tip="Loading" size="large"></Spin>
                        <p className="primary-color">Loading</p>
                    </div>
                ) : (
                    <>{children}</>
                )}
            </div>
        </main>
    )
}
